if (!window.__crucAddToQuoteContextFix) {
  window.__crucAddToQuoteContextFix = true;

  function syncQuoteContext(root) {
    root.querySelectorAll('.add_to_quote-app').forEach(function (wrapper) {
      var container = wrapper.querySelector('quote-container');
      if (!container) return;

      var data = wrapper.dataset;
      if (data.productId) container.setAttribute('data-product-id', data.productId);
      if (data.productTitle) container.setAttribute('data-product-title', data.productTitle);
      if (data.productPrice) container.setAttribute('data-product-price', data.productPrice);
      if (data.productImage) container.setAttribute('data-product-image', data.productImage);
    });
  }

  // CD-239: en related-products (recomendaciones fetched por product-recommendations.js),
  // quote-container cachea sus atributos al conectarse al DOM (connectedCallback), no al
  // click. El objeto global `product` de la PDP hace que esos atributos salgan ya
  // completos pero con el producto equivocado (el de la PDP), así que el fallback del
  // wrapper nunca se dispara. Hay que corregirlos ANTES de que el fragmento entre al DOM
  // conectado, parcheando el punto donde Dawn arma el HTML fetchado.
  var productRecommendationsCtor = window.customElements.get('product-recommendations');
  if (productRecommendationsCtor) {
    productRecommendationsCtor.prototype.loadRecommendations = function (productId) {
      var element = this;
      fetch(element.dataset.url + '&product_id=' + productId + '&section_id=' + element.dataset.sectionId)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          syncQuoteContext(html);

          var recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            element.innerHTML = recommendations.innerHTML;
          }

          if (!element.querySelector('slideshow-component') && element.classList.contains('complementary-products')) {
            element.remove();
          }

          if (html.querySelector('.grid__item')) {
            element.classList.add('product-recommendations--loaded');
          }
        })
        .catch(function (e) {
          console.error(e);
        });
    };
  }
}
